import { resolveComponent as s, openBlock as e, createElementBlock as a, createVNode as h, createElementVNode as r, toDisplayString as i, createBlock as c, withCtx as d, createTextVNode as m, createCommentVNode as l, defineAsyncComponent as T, normalizeClass as g, Fragment as I, resolveDynamicComponent as N, renderSlot as L } from "vue";
import { _ as C } from "./_plugin-vue_export-helper-dad06003.js";
import { S as A, W as F, I as W } from "./InformationCircleIcon-0c693620.js";
import { B as x } from "./ButtonSecondarySm-f6b60373.js";
import { B as p } from "./ButtonTertiarySm-e75d8ddc.js";
import { B as v, a as V } from "./ButtonPlay-d3872713.js";
import { A as X } from "./AlertCircleIcon-61966fff.js";
import { C as P } from "./CheckCircleIcon-17128890.js";
import { C as E } from "./CardPreloader-af882dfc.js";
import "./CardVideo-a346405d.js";
import "./FormRichText.model-53e072ea.js";
import "./glightbox-13d8fc52.js";
import "./PreloaderIcon-b44be854.js";
import "./XIcon-e21df3cc.js";
import "./HelpIcon-2069ddad.js";
import "./useNotificationHandler.js";
import "./DownloadFileIcon-8a003268.js";
import "./BarProgressMd-c3ebb73b.js";
import "./ButtonCloseSm-209b27c6.js";
import "./ChevronLeftIcon-b6affe9b.js";
import "./_commonjsHelpers-10dfc225.js";
const G = {
  name: "NotificationIcon",
  components: {
    StarsIcon: A,
    ButtonSecondarySm: x,
    ButtonTertiarySm: p,
    ButtonCloseXs: v
  },
  props: {
    icon: {
      type: String,
      default: "StarsIcon"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    ctaLabel: {
      type: String,
      default: ""
    },
    ctaCallback: {
      type: Function,
      default: () => {
      }
    },
    altLabel: {
      type: String,
      default: ""
    },
    altCallback: {
      type: Function,
      default: () => {
      }
    }
  },
  emits: ["close"]
}, j = { class: "relative flex flex-col sm:flex-row p-4 ct-bg-2--alt border border-dashed ct-border-1 rounded-xl" }, D = { class: "mt-4 sm:mt-0 sm:ml-4 sm:mr-8" }, O = { class: "ct-fg-1 text-base font-medium" }, z = { class: "mt-2 ct-fg-2 text-sm" }, U = {
  key: 0,
  class: "mt-5 flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3"
};
function q(o, n, t, S, k, u) {
  const f = s("StarsIcon"), y = s("ButtonSecondarySm"), b = s("ButtonTertiarySm"), _ = s("ButtonCloseXs");
  return e(), a("div", j, [
    h(f, { class: "flex-shrink-0 h-5 w-5 text-gray-500 dark:text-neutral-200" }),
    r("div", D, [
      r("p", O, i(t.title), 1),
      r("p", z, i(t.subtitle), 1),
      t.ctaLabel || t.altLabel ? (e(), a("div", U, [
        t.ctaLabel ? (e(), c(y, {
          key: 0,
          onClick: t.ctaCallback
        }, {
          default: d(() => [
            m(i(t.ctaLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0),
        t.altLabel ? (e(), c(b, {
          key: 1,
          onClick: t.altCallback
        }, {
          default: d(() => [
            m(i(t.altLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0)
      ])) : l("", !0)
    ]),
    h(_, {
      class: "absolute top-2 right-2",
      onClick: n[0] || (n[0] = (B) => o.$emit("close"))
    })
  ]);
}
const ee = /* @__PURE__ */ C(G, [["render", q]]), H = T(() => import("./CardGalleryPreview-a1bc6b63.js")), J = {
  name: "NotificationWithVideo",
  components: {
    ButtonSecondarySm: x,
    ButtonCloseXs: v,
    ButtonPlay: V,
    CardGalleryPreview: H,
    ButtonTertiarySm: p
  },
  props: {
    altCallback: {
      type: Function,
      default: () => {
      }
    },
    altLabel: {
      type: String,
      default: ""
    },
    ctaCallback: {
      type: Function,
      default: () => {
      }
    },
    ctaLabel: {
      type: String,
      default: ""
    },
    ctaPlaysVideo: {
      type: Boolean,
      default: !1
    },
    dontApplyAspectVideo: {
      // do not apply `css` class 'aspect-video' - to handle absolute container well...
      type: Boolean,
      default: !1
    },
    icon: {
      type: String,
      default: "StarsIcon"
    },
    subtitle: {
      type: String,
      default: ""
    },
    thumbnail: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    videoSrc: {
      type: String,
      default: ""
    },
    videoType: {
      type: String,
      default: "video"
      // use "external" for iframe elements !!!
    },
    wistiaId: {
      type: String,
      default: ""
    }
  },
  emits: ["close"],
  data() {
    return {
      galleryOpened: !1,
      reloadWistia: !1
      // trick to refresh UI after prop change!
    };
  },
  computed: {
    images() {
      return [
        {
          src: this.videoSrc,
          thumbnail: this.thumbnail,
          type: this.videoType
        }
      ];
    },
    isWistiaVideo() {
      return !!this.wistiaId;
    }
  },
  watch: {
    wistiaId: {
      handler(o, n) {
        o && o !== n && (this.removeAppendedScripts(), this.reloadWistia = !0, this.$nextTick(() => {
          this.libScript = document.createElement("script"), this.libScript.src = "https://fast.wistia.com/assets/external/E-v1.js", this.libScript.async = !0, this.videoScript = document.createElement("script"), this.videoScript.src = `https://fast.wistia.com/embed/medias/${this.wistiaId}.jsonp`, this.videoScript.async = !0, document.body.appendChild(this.libScript), document.body.appendChild(this.videoScript), this.reloadWistia = !1;
        }));
      },
      immediate: !0
    }
  },
  beforeUnmount() {
    this.removeAppendedScripts();
  },
  methods: {
    showGallery() {
      var o, n, t;
      this.isWistiaVideo ? (t = (n = (o = this.$refs.wistiaEmbed) == null ? void 0 : o.firstChild) == null ? void 0 : n.firstChild) == null || t.click() : this.galleryOpened = !0;
    },
    hideGallery() {
      this.galleryOpened = !1;
    },
    handleCtaClick() {
      this.ctaPlaysVideo ? this.showGallery() : this.ctaCallback();
    },
    removeAppendedScripts() {
      this.libScript && document.body.removeChild(this.libScript), this.videoScript && document.body.removeChild(this.videoScript);
    }
  }
}, K = { class: "relative flex flex-col sm:flex-row p-4 ct-bg-2--alt border border-dashed ct-border-1 rounded-xl sm:items-start" }, M = {
  key: 0,
  class: "wistia_responsive_padding",
  style: { padding: "56.25% 0 0 0", position: "relative" }
}, Q = {
  class: "wistia_responsive_wrapper",
  style: { height: "100%", left: "0", position: "absolute", top: "0", width: "100%" }
}, R = ["src"], Y = { class: "cursor-pointer absolute inset-0 bg-white dark:bg-black flex items-center justify-center bg-opacity-30 dark:bg-opacity-30 hover:bg-opacity-15 dark:hover:bg-opacity-15" }, Z = { class: "order-0 sm:order-1 flex-grow mt-4 sm:mt-0 sm:ml-4 sm:mr-8" }, $ = { class: "ct-fg-1 text-base font-medium" }, tt = { class: "mt-2 ct-fg-2 text-sm" }, et = {
  key: 0,
  class: "mt-5 hidden sm:flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3"
}, lt = {
  key: 0,
  class: "order-2 mt-5 flex sm:hidden flex-col space-y-3"
};
function at(o, n, t, S, k, u) {
  const f = s("ButtonPlay"), y = s("ButtonSecondarySm"), b = s("ButtonTertiarySm"), _ = s("ButtonCloseXs"), B = s("CardGalleryPreview");
  return e(), a("div", K, [
    r("div", {
      class: g(["mt-5 sm:mt-0 order-1 sm:order-0 relative flex-shrink-0 w-full sm:w-[191px] rounded-md overflow-hidden", t.dontApplyAspectVideo ? "" : "aspect-video"]),
      onClick: n[0] || (n[0] = (...w) => u.showGallery && u.showGallery(...w))
    }, [
      u.isWistiaVideo ? (e(), a(I, { key: 0 }, [
        k.reloadWistia ? l("", !0) : (e(), a("div", M, [
          r("div", Q, [
            r("span", {
              ref: "wistiaEmbed",
              class: g(["wistia_embed popover=true videoFoam=true", [`wistia_async_${t.wistiaId}`]]),
              style: { display: "inline-block", height: "100%", position: "relative", width: "100%" }
            }, "   ", 2)
          ])
        ]))
      ], 64)) : (e(), a(I, { key: 1 }, [
        t.thumbnail ? (e(), a("img", {
          key: 0,
          class: "w-full h-full object-cover",
          src: t.thumbnail
        }, null, 8, R)) : l("", !0),
        r("div", Y, [
          h(f)
        ])
      ], 64))
    ], 2),
    r("div", Z, [
      r("p", $, i(t.title), 1),
      r("p", tt, i(t.subtitle), 1),
      t.ctaLabel || t.altLabel ? (e(), a("div", et, [
        t.ctaLabel ? (e(), c(y, {
          key: 0,
          onClick: u.handleCtaClick
        }, {
          default: d(() => [
            m(i(t.ctaLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0),
        t.altLabel ? (e(), c(b, {
          key: 1,
          onClick: t.altCallback
        }, {
          default: d(() => [
            m(i(t.altLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0)
      ])) : l("", !0)
    ]),
    t.ctaLabel || t.altLabel ? (e(), a("div", lt, [
      t.ctaLabel ? (e(), c(y, {
        key: 0,
        onClick: u.handleCtaClick
      }, {
        default: d(() => [
          m(i(t.ctaLabel), 1)
        ]),
        _: 1
      }, 8, ["onClick"])) : l("", !0),
      t.altLabel ? (e(), c(b, {
        key: 1,
        onClick: t.altCallback
      }, {
        default: d(() => [
          m(i(t.altLabel), 1)
        ]),
        _: 1
      }, 8, ["onClick"])) : l("", !0)
    ])) : l("", !0),
    h(_, {
      class: "absolute top-2 right-2",
      onClick: n[1] || (n[1] = (w) => o.$emit("close"))
    }),
    k.galleryOpened ? (e(), c(B, {
      key: 1,
      media: u.images,
      onClose: u.hideGallery
    }, null, 8, ["media", "onClose"])) : l("", !0)
  ]);
}
const le = /* @__PURE__ */ C(J, [["render", at]]), ot = {
  name: "NotificationAlert",
  components: {
    WarningDiamondIcon: F,
    ButtonSecondarySm: x,
    ButtonTertiarySm: p,
    ButtonCloseXs: v
  },
  props: {
    icon: {
      type: [Object, String],
      default: "WarningDiamondIcon"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    ctaLabel: {
      type: String,
      default: ""
    },
    ctaCallback: {
      type: Function,
      default: () => {
      }
    },
    ctaLink: {
      type: String,
      default: ""
    },
    altLabel: {
      type: String,
      default: ""
    },
    altCallback: {
      type: Function,
      default: () => {
      }
    },
    closeButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"]
}, it = { class: "relative flex flex-col sm:flex-row p-4 ct-bg-warning--1 border border-warning-500 dark:border-warning-400 rounded-xl" }, nt = {
  key: 0,
  class: "ct-fg-1 text-base font-medium"
}, st = {
  key: 3,
  class: "mt-5 flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3"
};
function ct(o, n, t, S, k, u) {
  const f = s("ButtonSecondarySm"), y = s("ButtonTertiarySm"), b = s("ButtonCloseXs");
  return e(), a("div", it, [
    (e(), c(N(t.icon || "WarningDiamondIcon"), { class: "flex-shrink-0 h-5 w-5 text-warning-600 dark:text-warning-500" })),
    r("div", {
      class: g(["mt-4 sm:mt-0 sm:ml-4", [t.closeButton ? "sm:mr-8" : ""]])
    }, [
      t.title ? (e(), a("p", nt, i(t.title), 1)) : l("", !0),
      t.subtitle && !o.$slots.default ? (e(), a("p", {
        key: 1,
        class: g(["ct-fg-2 text-sm", { "mt-2": !!t.title }])
      }, i(t.subtitle), 3)) : l("", !0),
      o.$slots.default ? (e(), a("div", {
        key: 2,
        class: g(["ct-fg-2 text-sm", { "mt-2": !!t.title }])
      }, [
        L(o.$slots, "default")
      ], 2)) : l("", !0),
      t.ctaLabel || t.altLabel ? (e(), a("div", st, [
        (e(), c(N(t.ctaLink ? "a" : "div"), { href: t.ctaLink }, {
          default: d(() => [
            t.ctaLabel ? (e(), c(f, {
              key: 0,
              onClick: t.ctaCallback
            }, {
              default: d(() => [
                m(i(t.ctaLabel), 1)
              ]),
              _: 1
            }, 8, ["onClick"])) : l("", !0)
          ]),
          _: 1
        }, 8, ["href"])),
        t.altLabel ? (e(), c(y, {
          key: 0,
          onClick: t.altCallback
        }, {
          default: d(() => [
            m(i(t.altLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0)
      ])) : l("", !0)
    ], 2),
    t.closeButton ? (e(), c(b, {
      key: 0,
      class: "absolute top-2 right-2",
      onClick: n[0] || (n[0] = (_) => o.$emit("close"))
    })) : l("", !0)
  ]);
}
const ae = /* @__PURE__ */ C(ot, [["render", ct]]), rt = {
  name: "NotificationIcon",
  components: {
    InformationCircleIcon: W,
    ButtonSecondarySm: x,
    ButtonTertiarySm: p,
    ButtonCloseXs: v
  },
  props: {
    icon: {
      type: String,
      default: "StarsIcon"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    ctaLabel: {
      type: String,
      default: ""
    },
    ctaCallback: {
      type: Function,
      default: () => {
      }
    },
    altLabel: {
      type: String,
      default: ""
    },
    altCallback: {
      type: Function,
      default: () => {
      }
    },
    closeButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"]
}, dt = { class: "relative flex flex-col sm:flex-row p-4 ct-bg-3 border ct-border-1 rounded-xl" }, mt = {
  key: 0,
  class: "ct-fg-1 text-base font-medium mb-2"
}, ut = {
  key: 1,
  class: "mb-2 ct-fg-2 text-sm"
}, ft = {
  key: 2,
  class: "ct-fg-2 text-sm"
}, yt = {
  key: 3,
  class: "mt-5 flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3"
};
function bt(o, n, t, S, k, u) {
  const f = s("InformationCircleIcon"), y = s("ButtonSecondarySm"), b = s("ButtonTertiarySm"), _ = s("ButtonCloseXs");
  return e(), a("div", dt, [
    h(f, { class: "flex-shrink-0 h-5 w-5 ct-fg-brand" }),
    r("div", {
      class: g(["mt-4 sm:mt-0 sm:ml-4", [t.closeButton ? "sm:mr-8" : ""]])
    }, [
      t.title ? (e(), a("p", mt, i(t.title), 1)) : l("", !0),
      t.subtitle && !o.$slots.default ? (e(), a("p", ut, i(t.subtitle), 1)) : l("", !0),
      o.$slots.default ? (e(), a("div", ft, [
        L(o.$slots, "default")
      ])) : l("", !0),
      t.ctaLabel || t.altLabel ? (e(), a("div", yt, [
        t.ctaLabel ? (e(), c(y, {
          key: 0,
          onClick: t.ctaCallback
        }, {
          default: d(() => [
            m(i(t.ctaLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0),
        t.altLabel ? (e(), c(b, {
          key: 1,
          onClick: t.altCallback
        }, {
          default: d(() => [
            m(i(t.altLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0)
      ])) : l("", !0)
    ], 2),
    t.closeButton ? (e(), c(_, {
      key: 0,
      class: "absolute top-2 right-2",
      onClick: n[0] || (n[0] = (B) => o.$emit("close"))
    })) : l("", !0)
  ]);
}
const oe = /* @__PURE__ */ C(rt, [["render", bt]]), _t = {
  name: "NotificationError",
  components: {
    AlertCircleIcon: X,
    ButtonSecondarySm: x,
    ButtonTertiarySm: p,
    ButtonCloseXs: v
  },
  props: {
    icon: {
      type: String,
      default: "StarsIcon"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    ctaLabel: {
      type: String,
      default: ""
    },
    ctaCallback: {
      type: Function,
      default: () => {
      }
    },
    altLabel: {
      type: String,
      default: ""
    },
    altCallback: {
      type: Function,
      default: () => {
      }
    },
    closeButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"]
}, kt = { class: "relative flex flex-col sm:flex-row p-4 ct-bg-error--1 border border-error-500 dark:border-error-400 rounded-xl" }, ht = { class: "mt-4 sm:mt-0 sm:ml-4 sm:mr-8" }, Ct = {
  key: 0,
  class: "ct-fg-1 text-base font-medium mb-2"
}, St = {
  key: 1,
  class: "mb-2 ct-fg-2 text-sm"
}, gt = {
  key: 2,
  class: "ct-fg-2 text-sm"
}, xt = {
  key: 3,
  class: "mt-5 flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3"
};
function pt(o, n, t, S, k, u) {
  const f = s("AlertCircleIcon"), y = s("ButtonSecondarySm"), b = s("ButtonTertiarySm"), _ = s("ButtonCloseXs");
  return e(), a("div", kt, [
    h(f, { class: "flex-shrink-0 h-5 w-5 text-error-600 dark:text-error-500" }),
    r("div", ht, [
      t.title ? (e(), a("p", Ct, i(t.title), 1)) : l("", !0),
      t.subtitle && !o.$slots.default ? (e(), a("p", St, i(t.subtitle), 1)) : l("", !0),
      o.$slots.default ? (e(), a("div", gt, [
        L(o.$slots, "default")
      ])) : l("", !0),
      t.ctaLabel || t.altLabel ? (e(), a("div", xt, [
        t.ctaLabel ? (e(), c(y, {
          key: 0,
          onClick: t.ctaCallback
        }, {
          default: d(() => [
            m(i(t.ctaLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0),
        t.altLabel ? (e(), c(b, {
          key: 1,
          onClick: t.altCallback
        }, {
          default: d(() => [
            m(i(t.altLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0)
      ])) : l("", !0)
    ]),
    t.closeButton ? (e(), c(_, {
      key: 0,
      class: "absolute top-2 right-2",
      onClick: n[0] || (n[0] = (B) => o.$emit("close"))
    })) : l("", !0)
  ]);
}
const ie = /* @__PURE__ */ C(_t, [["render", pt]]), vt = {
  name: "NotificationError",
  components: {
    CheckCircleIcon: P,
    ButtonSecondarySm: x,
    ButtonTertiarySm: p,
    ButtonCloseXs: v
  },
  props: {
    icon: {
      type: String,
      default: "StarsIcon"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    ctaLabel: {
      type: String,
      default: ""
    },
    ctaCallback: {
      type: Function,
      default: () => {
      }
    },
    altLabel: {
      type: String,
      default: ""
    },
    altCallback: {
      type: Function,
      default: () => {
      }
    },
    closeButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"]
}, Bt = { class: "relative flex flex-col sm:flex-row p-4 ct-bg-success--1 border border-success-500 dark:border-success-400 rounded-xl" }, Lt = { class: "mt-4 sm:mt-0 sm:ml-4 sm:mr-8" }, wt = { class: "ct-fg-1 text-base font-medium" }, It = {
  key: 0,
  class: "mt-2 ct-fg-2 text-sm"
}, Nt = {
  key: 1,
  class: "mt-5 flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3"
};
function Tt(o, n, t, S, k, u) {
  const f = s("CheckCircleIcon"), y = s("ButtonSecondarySm"), b = s("ButtonTertiarySm"), _ = s("ButtonCloseXs");
  return e(), a("div", Bt, [
    h(f, { class: "flex-shrink-0 h-5 w-5 text-success-600 dark:text-success-500" }),
    r("div", Lt, [
      r("p", wt, i(t.title), 1),
      t.subtitle ? (e(), a("p", It, i(t.subtitle), 1)) : l("", !0),
      t.ctaLabel || t.altLabel ? (e(), a("div", Nt, [
        t.ctaLabel ? (e(), c(y, {
          key: 0,
          onClick: t.ctaCallback
        }, {
          default: d(() => [
            m(i(t.ctaLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0),
        t.altLabel ? (e(), c(b, {
          key: 1,
          onClick: t.altCallback
        }, {
          default: d(() => [
            m(i(t.altLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : l("", !0)
      ])) : l("", !0)
    ]),
    t.closeButton ? (e(), c(_, {
      key: 0,
      class: "absolute top-2 right-2",
      onClick: n[0] || (n[0] = (B) => o.$emit("close"))
    })) : l("", !0)
  ]);
}
const ne = /* @__PURE__ */ C(vt, [["render", Tt]]), At = {
  name: "NotificationLoading",
  components: {
    CardPreloader: E
  }
}, Ft = { class: "relative flex flex-col sm:flex-row p-4 ct-bg-2--alt border border-dashed ct-border-1 rounded-xl h-36" };
function Wt(o, n, t, S, k, u) {
  const f = s("CardPreloader");
  return e(), a("div", Ft, [
    h(f)
  ]);
}
const se = /* @__PURE__ */ C(At, [["render", Wt]]);
export {
  ae as NotificationAlert,
  ie as NotificationError,
  oe as NotificationInfo,
  se as NotificationLoading,
  ne as NotificationSuccess,
  ee as NotificationWithIcon,
  le as NotificationWithVideo
};
